function getEnvVar(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (!value) throw new Error(`${name} environment variable is not defined`);
  return value;
}

const oidcEndpoint = getEnvVar("VITE_OIDC_ENDPOINT");
const oidcClientId = getEnvVar("VITE_OIDC_CLIENTID");

export const wsEndpoint = getEnvVar("VITE_WS_ENDPOINT");

const redirectUri = getEnvVar("VITE_REDIRECT_URI");
const postLogoutUri = getEnvVar("VITE_POSTLOGOUT_REDIRECT_URI");

export const apiConfig = {
  endpoint: "",
};

// react-oidc-context configuration
export const oidcConfig = {
  authority: oidcEndpoint,
  client_id: oidcClientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutUri,
  scope: "openid profile email",
  automaticSilentRenew: true,
};
